import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import { buscarUsuariosSistema, buscarPerfis } from '../../actions/usuario/buscarUsuarios';
import excluirUsuario from '../../actions/usuario/exclurUsuario';
import { alterouFiltro, alterouPagina } from '../../util/filtros';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import Usuario from './empresa/Usuario'
import ModalCadastrarUsuario from './empresa/ModalCadastrarUsuario';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import PaginacaoUsuarios from './PaginacaoUsuarios';
import BotoesPaginacaoUsuarios from './BotoesPaginacaoUsuarios';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import determinarPaginaAtual from '../../actions/usuario/determinarPaginaAtualUsuarios';
import alterarRegistrosPorPagina from '../../actions/usuario/alterarRegistrosPorPaginaUsuarios';
import ModalAlterarUsuario from './empresa/ModalAlterarUsuario';
import PainelFiltragem from './empresa/PainelFiltrosUsuarios';
import ModalCadastrarUsuarioDescontoRota from './empresa/ModalCadastrarUsuarioDescontoRota';
import buscarRotas from '../../actions/rota/buscarRotas';
import ModalRelacionarAgenciaUsuario from './empresa/ModalRelacionarAgenciaUsuario';
import buscarAgencias from '../../actions/agencia/buscarAgencias';
import bloquearUsuario from '../../actions/usuario/bloquearUsuario';
import desbloquearUsuario from '../../actions/usuario/desbloquearUsuario';
import ModalCadastrarMotorista from './empresa/ModalCadastrarMotorista';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro, FILTRO_CODIGO_USUARIO, FILTRO_EMAIL_USUARIO } from '../../util/filtros';
import { gerarHashForString } from '../../util/stringUtil';
import bloquearUsuarioEmLote from '../../actions/usuario/bloquearUsuarioEmLote';
import desbloquearUsuarioEmLote from '../../actions/usuario/desbloquearUsuarioEmLote';
import { showSuccessMsg } from '../../util/messagesUtil';
import ModalImportarUsuariosSistema from './ModalImportarUsuariosSistema';
import buscarEmpresa from '../../actions/empresa/buscarEmpresas';
import importarUsuariosEmpresa from '../../actions/usuario/importarUsuariosEmpresa';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div className="row cabecalho-desktop">
            <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">Número</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Nome</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Email</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Empresa</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Telefone</div>
            <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1">Data de criação</div>
            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">Ações</div>
        </div>
    </div>
);

const ModalConfirmacaoBloqueioDesbloqueio = ({ usuario, bloquearDesbloquear }) => (
    <div className="modal fade" id="modalConfirmacaoBloqueioDesbloqueio" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoBloqueioDesbloqueio" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p><strong>{`Deseja ${usuario.bloqueado ? 'desbloquear' : 'bloquear'} ${usuario.nome}`}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => bloquearDesbloquear()}>Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>);

const ModalConfirmacaoBloquearDesbloquearUsuarioEmLote = ({ usuario, bloquearDesbloquearUsuarioEmLote, isBloqueado }) => (
    <div className="modal fade" id="modalConfirmacaoBloquearDesbloquearUsuarioEmLote" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoBloquearDesbloquearUsuarioEmLote" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-body texto-centralizado">
                    <p><strong>{`Deseja ${usuario.bloqueado ? 'desbloquear' : 'bloquear'} ${usuario.nome}`}</strong></p>
                </div>
                <div className="modal-footer ">
                    <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal">Cancelar
                    </button>
                    <button type="button" className="btn btn-laranja float-left" data-dismiss="modal"
                        onClick={() => bloquearDesbloquearUsuarioEmLote(isBloqueado)}>Confirmar
                    </button>
                </div>
            </div>
        </div>
    </div>);

export class PainelGerenciarUsuarioSistema extends React.Component {
    constructor(props) {
        super(props);
        this.limparCampos = this.limparCampos.bind(this);
        this.buscarUsuario = this.buscarUsuario.bind(this);
        this.bloquearDesbloquear = this.bloquearDesbloquear.bind(this);
        this.bloquearDesbloquearUsuarioEmLote = this.bloquearDesbloquearUsuarioEmLote.bind(this);
        this.state = {
            usuarioSelecionado: null,
            textoFiltro: null,
            perfis: [],
            linksSelecionados: [],
            linksSelecionadosModalEdicao: [],
            usuarioFiltradoBloqueado: false,
            usuariosFiltrados: null
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.buscarUsuario();
            this.props.buscarPerfis().then(resp => this.setState({ perfis: resp.payload.data }))
            this.props.buscarAgencias(this.props.empresaSelecionada.id);
            this.props.buscarRotas(this.props.empresaSelecionada.id);
            this.props.buscarEmpresa()
        }
    }


    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
                this.props.alterarRegistrosPorPagina(10);
            }
            this.buscarUsuario()
        }
    }

    buscarUsuario() {
        this.props.buscarUsuariosSistema(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados)
            .then(response => {
                if (response.payload.status === 200) {
                    const usuariosFiltrados = this.verificarFiltrosAplicados(response.payload.data);
                    this.setState({ usuariosFiltrados });
                }
            });
    }

    verificarFiltrosAplicados(data) {
        const { filtrosAdicionados } = this.props;

        if (filtrosAdicionados.length > 0) {
            for (const filtro of filtrosAdicionados) {
                if (filtro.chave == FILTRO_CODIGO_USUARIO.chave || filtro.chave == FILTRO_EMAIL_USUARIO.chave) {
                    return data.usuarios[0]
                }

            }
        }

        return null;
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'idUsuario', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'email', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'perfil', '');
    }

    bloquearDesbloquear() {
        if (this.props.usuarioSelecionado.bloqueado) {
            this.props.desbloquearUsuario(this.props.usuarioSelecionado.id, this.props.usuarioSelecionado.idEmpresa)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuario();
                    }
                })
        } else {
            this.props.bloquearUsuario(this.props.usuarioSelecionado.id, this.props.usuarioSelecionado.idEmpresa)
                .then(response => {
                    if (response.payload.status == 200) {
                        this.buscarUsuario();
                    }
                })
        }
    }

    bloquearDesbloquearUsuarioEmLote(bloqueioEmLote) {
        const temUsuarioFiltrado = this.state.usuariosFiltrados;
        if (bloqueioEmLote) {
            if (temUsuarioFiltrado) {
                this.props.bloquearUsuarioEmLote(this.state.usuariosFiltrados.id)
                    .then(response => {
                        if (response && response.payload.status === 200) {
                            showSuccessMsg('Usuário bloqueado com sucesso!')
                            this.buscarUsuario();
                        }
                    })
            }
        } else {
            if (temUsuarioFiltrado) {
                this.props.desbloquearUsuarioEmLote(this.state.usuariosFiltrados.id)
                    .then(response => {
                        if (response && response.payload.status === 200) {
                            showSuccessMsg('Usuário desbloqueado com sucesso!')
                            this.buscarUsuario();
                        }
                    })
            }
        }
    }

    limparFormulario() {
        this.props.reset('formularioCadastroUsuario');
        this.setState({ perfisSelecionados: [] })
        this.props.limparPerfis()
        this.buscarUsuario();
    }

    async downloadParte(url, size, from) {
        const urlFiltros = montarURLFiltro(this.props.filtrosAdicionados);

        let urlReq = `${url}?size=${size}&from=${from}&${urlFiltros}`;
        let retorno = await axios.get(urlReq, SLOW_REQUEST_CONFIG);

        return retorno.data;
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], { type: 'text/csv;' }));
        a.download = 'Lista de Usuários Sistema.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async exportarListaUsuarios() {
        let arquivo = 'Número;Nome;E-mail;Empresa;Telefone;Data de criação;Situação\n';
        let url = `${URL}/usuarios/sistema`;

        let count = 0;
        let from = 1;
        let size = 10000;

        let qtd = this.props.total;
        let totalParticoes = Math.ceil(qtd / 10000);

        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, size, from);

            arquivo = `${arquivo}${retorno.usuarios.map(it => {

                const situacao = it.ativo ? 'Ativo' : 'Inativo';
                const telefone = it.telefone ? it.telefone.replace(/\D/g, '').replace(/^(\d{2})(\d)/g, '($1) $2').replace(/(\d)(\d{4})$/, '$1-$2') : 'Sem telefone';

                let valor = `${it.id};${it.nome};${it.email};"${it.nomeEmpresa}";"${telefone}";"${it.dataCriacao}";"${situacao}"`

                return valor;

            }).join('\n')}\n`;

            from += 1;
            count += 1;

            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }
        }
    }

    exibirBotaoExportarLista() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <button className="btn btn-laranja mr-2"
                    onClick={() => this.exportarListaUsuarios()}>
                    Exportar Lista
                </button>
            </Autorizacao>)
    }

    exibirBotaoImportarUsuarios() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <button data-toggle="modal"
                        data-target="#modalImportarUsuarios"
                        className="btn btn-laranja mr-2">
                    Importar Usuários
                </button>
            </Autorizacao>
        )
    }

    // eslint-disable-next-line class-methods-use-this
    exibirBotoes() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="dropdown text-right">
                            {this.exibirBotaoImportarUsuarios()}
                            {this.exibirBotaoExportarLista()}
                            <button data-toggle="modal" data-target="#modalCadastrarUsuario"
                                className="btn btn-laranja">
                                Cadastrar usuário
                            </button>
                            <button onClick={() => this.props.history.push('/painel-cadastro-usuarios-empresa-lote')} className="btn btn-laranja ml-2 mt-sm-2 mt-2 mt-md-0 mt-lg-0 mt-xl-0">
                                Cadatrar usuário em lote
                            </button>
                            {this.state.usuariosFiltrados && <> <button className="btn btn-laranja ml-2 mt-sm-2 mt-2 mt-md-0 mt-lg-0 mt-xl-0 dropdown-toggle" type="button" id="dropdownMenuButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Ações em lote
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item btn btn-laranja"
                                    data-toggle="modal"
                                    data-target="#modalConfirmacaoBloquearDesbloquearUsuarioEmLote"
                                    onClick={() => this.setState({usuarioFiltradoBloqueado: true})}>
                                    Bloquear Usuário em lote</a>
                                <a className="dropdown-item btn btn-laranja"
                                    data-toggle="modal"
                                    data-target="#modalConfirmacaoBloquearDesbloquearUsuarioEmLote"
                                    onClick={() => this.setState({usuarioFiltradoBloqueado: false})}>
                                    Desbloquear Usuário em lote</a>
                            </div> </>}
                        </div>
                    </div>
                </div>
            </Autorizacao>)
    }


    exibirTabelaUsuarios() {
        if (this.props.usuarios && this.props.usuarios.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoUsuarios}
                    BotoesPaginacao={BotoesPaginacaoUsuarios}>
                    <CabecalhoTabela />
                    <div className="lista-table">
                        {this.exibirUsuarios()}
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhum usuário cadastrado para a empresa</div>;
    }

    exibirUsuarios() {
        return this.props.usuarios
            .map((usuario, index) => <Usuario key={index} usuario={usuario}
                indice={index}
                usuarioSistema={true}
                preencherModalEdicao={this.preencherModalEdicao.bind(this)} />)
    }

    preencherModalEdicao(usuarioSelecionado) {
        const links = usuarioSelecionado.links.map(it => { return { hash: gerarHashForString(`${it.tipo}`), id: it.id, tipo: it.tipo, url: it.url } });
        this.setState({ linksSelecionadosModalEdicao: links });
    }

    alterarValoresLinksSelecionados(links) {
        this.setState({ linksSelecionadosModalEdicao: links });
    }

    limparLinks() {
        this.setState({ linksSelecionadosModalEdicao: [] });
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Usuários" urlRetorno="/menu-usuario" />
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem />
                            </div>
                            {this.exibirBotoes()}
                            {this.exibirTabelaUsuarios()}
                        </div>
                    </div>
                    <ModalCadastrarUsuario buscarUsuario={this.buscarUsuario} perfis={this.state.perfis} />
                    <ModalCadastrarMotorista />
                    <ModalAlterarUsuario perfis={this.state.perfis} buscarUsuario={this.buscarUsuario}
                        linksSelecionados={this.state.linksSelecionadosModalEdicao}
                        alterarValoresLinksSelecionados={this.alterarValoresLinksSelecionados.bind(this)}
                        limparLinks={this.limparLinks.bind(this)}
                    />
                    <ModalCadastrarUsuarioDescontoRota />
                    <ModalRelacionarAgenciaUsuario buscarUsuario={this.buscarUsuario} />
                    <ModalConfirmacaoBloqueioDesbloqueio
                        bloquearDesbloquear={this.bloquearDesbloquear}
                        usuario={this.props.usuarioSelecionado} />
                    <ModalConfirmacaoBloquearDesbloquearUsuarioEmLote
                        bloquearDesbloquearUsuarioEmLote={this.bloquearDesbloquearUsuarioEmLote}
                        usuario={this.state.usuariosFiltrados || {}}
                        isBloqueado={this.state.usuarioFiltradoBloqueado}
                    />
                    <ModalImportarUsuariosSistema empresas={this.props.empresas} 
                        importarUsuariosEmpresa={this.props.importarUsuariosEmpresa}
                        buscarUsuario={this.buscarUsuario}/>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = (state) => {
    return {
        usuarios: state.usuarios.usuarios,
        total: state.usuarios.total,
        usuarioSelecionado: state.usuarioSelecionado,
        empresaSelecionada: state.empresaSelecionada,
        perfisSelecionados: state.perfisSelecionados,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        changeFieldValue,
        filtrosAdicionados: state.filtrosAdicionadosUsuarios,
        empresas: state.empresas
    }
};


export default connect(mapStateToProps, {
    buscarUsuariosSistema,
    buscarPerfis,
    excluirUsuario,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    buscarRotas,
    buscarAgencias,
    desbloquearUsuario,
    bloquearUsuario,
    bloquearUsuarioEmLote,
    desbloquearUsuarioEmLote,
    buscarEmpresa,
    importarUsuariosEmpresa
})(reduxForm({
    form: 'formularioCadastroUsuario'
})(PainelGerenciarUsuarioSistema))
